import "./Solutions.css";
import Footer from "./Footer";
import solimg6 from "../assets/sol-img6.png";
import solimg7 from "../assets/sol-img7.png";
import pdcAutomation from "../assets/pdc-automation.png";
import gdcAutomation from "../assets/gdc-refined.png";
import machiningAutomation from "../assets/machining.png";


export default function SolEngineering() {
    return (
        <section id="sol-eng">
            {/* TOP SECTION */}
            <div className="lightweighting-wrapper-a">
                {/* LEFT CONTENT */}
                <div className="lightweighting-text-a">
                    <h3>Engineering</h3>
                    <h3>
                        Smart Manufacturing – Automation & Precision Engineering
                    </h3>

                    <p>
                        At SCL, we bridge design and production through advanced automation and intelligent engineering systems. From robotic casting cells to automated intralogistics, our plants are designed for speed, consistency and repeatability – taking programs from prototype validation to stable mass production with predictable quality.

                    </p>
                </div>
            </div>

            <h2 className="lightweighting-title">Casting & Machining Automation</h2>
            <div className="lig-underline"></div>
            <p className="sol-eng-para">We deploy state-of-the-art automation across our Pressure Die Casting (PDC), Gravity Die Casting (GDC), and machining lines to deliver consistent, high-quality output.</p>

            <div className="img-grid1">
                <img src={pdcAutomation} alt="PDC automation" />
                <img src={gdcAutomation} alt="GDC automation" />
                <img src={machiningAutomation} alt="Machining automation" />
            </div>

            <div className="dmp-wrapper">
                {/* CARD 1 */}
                <div className="dmp-card">
                    <div className="dmp-header">
                        PDC Cell Automation
                    </div>

                    <div className="dmp-body">
                        <p>
                            Robotic systems manage casting extraction, spraying, gate removal and deflashing, ensuring stable cycle times, repeatable shot quality and minimal manual intervention.
                        </p>
                    </div>
                </div>

                {/* CARD 2 */}
                <div className="dmp-card">
                    <div className="dmp-header">
                        GDC Cell Automation
                    </div>

                    <div className="dmp-body">
                        <p>
                            Integrated robotics handle metal pouring, casting extraction and post-casting operations, improving process consistency while greatly enhancing operator safety.
                        </p>
                    </div>
                </div>

                {/* CARD 3 */}
                <div className="dmp-card">
                    <div className="dmp-header">
                        Machining Cell Automation
                    </div>

                    <div className="dmp-body">
                        <p>Robots automate machine loading/unloading and post-machining handling. This keeps every component within tight tolerances, delivers consistent surface finish, and supports zero-defect objectives.</p>
                    </div>
                </div>
            </div>
            <div className="dmp-wrapper1">
                <div className="dmp-card">
                    <div className="dmp-header">
                        Key Benefits
                    </div>

                    <div className="dmp-body1">
                        <ul className="benefits-list">
                            <li>
                                <strong>Higher productivity:</strong> Faster cycles and continuous
                                operation for high-volume programs.
                            </li>
                            <li>
                                <strong>Consistent quality:</strong> Robotic precision reduces variation and defects.
                            </li>
                            <li>
                                <strong>Cost efficiency:</strong> Lower rework and optimized resource utilization.
                            </li>
                            <li>
                                <strong>Safer operations:</strong> Automation limits manual contact with hot parts and heavy tools.
                            </li>
                            <li>
                                <strong>Scalability:</strong> Cells can be adapted quickly for new part designs and volumes.
                            </li>
                        </ul>
                    </div>

                </div>
            </div>

            <h2 className="lightweighting-title">Material Handling Automation</h2>
            <div className="lig-underline"></div>
            <p className="sol-eng-para">Efficiency at SCL extends beyond the machine. Our Automated Storage & Retrieval Systems (ASRS) and Autonomous Mobile Robots (AMRs) redefine intralogistics with controlled, FIFO material flow and optimised space utilisation</p>

           

            <div className="dmp-wrapper2">
                {/* CARD 1 */}
                <div className="dmp-card">
                    <img src={solimg7} alt="AMR" style={{ width: "100%", borderRadius: "6px", marginBottom: "15px" }} />
                    <div className="dmp-header">
                        AMR – Autonomous Mobile Robots
                    </div>

                    <div className="dmp-body">
                        <p>
                            AMRs automate internal material movement – from ingots and castings to finished components and dies – reducing manual handling time, improving safety and cutting heat loss during hot-metal transfers and die changeovers.
                        </p>
                    </div>
                </div>

                {/* CARD 2 */}
                <div className="dmp-card">
                    <img src={solimg6} alt="ASRS" style={{ width: "100%", borderRadius: "6px", marginBottom: "15px" }} />
                    <div className="dmp-header">
                        ASRS – Automated Storage & Retrieval Systems
                    </div>

                    <div className="dmp-body">
                        <p>
                            High-density ASRS racks, fed by AMRs/AGVs, provide automated storage and retrieval of castings, tooling and components, using vertical space to increase capacity without expanding floor area.
                        </p>
                    </div>
                </div>
            </div>
            <div className="dmp-wrapper1">
                <div className="dmp-card">
                    <div className="dmp-header">
                        Key Benefits
                    </div>

                    <div className="dmp-body">
                        <ul className="benefits-list">
                            <li>
                                <strong>Accurate tracking:</strong> Real-time inventory and WIP visibility for reliable planning.
                            </li>
                            <li>
                                <strong>Faster throughput:</strong> Automated movement shortens response and changeover times.
                            </li>
                            <li>
                                <strong>Flexible & safe:</strong> Smart navigation adapts to layout changes while improving safety.
                            </li>
                            <li><strong>Optimized space:</strong> Vertical storage and lean flow free up valuable shop-floor area.</li>
                        </ul>
                    </div>

                </div>
            </div>

            <p className="sol-eng-para sol-eng-para-final">This combination of robotic production cells and intelligent intralogistics ensures that SCL's manufacturing system is not only automated, but genuinely smart – capable of delivering the consistency, responsiveness and cost competitiveness customers expect from a strategic long-term partner.</p>

            <Footer />
        </section>
    );
}